import api from './api';
import { Markup, CreateMarkupRequest, UpdateMarkupRequest } from '../interfaces/Markup';

export const markupService = {
  async getMarkups(): Promise<Markup[]> {
    const response = await api.get('/read/markups');
    return response.data;
  },

  async getMarkupById(id: number): Promise<Markup> {
    const response = await api.get(`/read/markups/${id}`);
    return response.data;
  },

  async createMarkup(markup: CreateMarkupRequest): Promise<Markup> {
    const response = await api.post('/write/markups', markup);
    return response.data;
  },

  async updateMarkup(id: number, markup: UpdateMarkupRequest): Promise<Markup> {
    const response = await api.patch(`/write/markups/${id}`, markup);
    return response.data;
  },

  async deleteMarkup(id: number): Promise<void> {
    await api.delete(`/write/markups/${id}`);
  },
};